module.exports = __webpack_public_path__ + "img/no-filter.fc18e967.svg";